"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const helperCreateElement_1 = require("./helperCreateElement");
const Header = ({ currentMoment, selectedMoment = moment_1.default(), leftIconId, rightIconId, minDate, maxDate, }) => {
    if (currentMoment.get('month') === 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("strong", { style: { textTransform: 'capitalize' } }, currentMoment.format('MMMM')),
            react_1.default.createElement("span", { style: { fontWeight: 400 } }, ` ${currentMoment.format('YYYY')}`)));
    }
    if (selectedMoment.get('month') ===
        moment_1.default().subtract(minDate, 'months').startOf('month').get('month') &&
        selectedMoment.get('year') ===
            moment_1.default().subtract(minDate, 'months').startOf('month').get('year')) {
        helperCreateElement_1.createLeftButton(leftIconId);
    }
    if (selectedMoment.get('month') ===
        moment_1.default()
            .add(maxDate ? maxDate - 1 : maxDate, 'months')
            .endOf('month')
            .get('month') &&
        selectedMoment.get('year') ===
            moment_1.default()
                .add(maxDate ? maxDate - 1 : maxDate, 'months')
                .endOf('month')
                .get('year')) {
        helperCreateElement_1.createRightButton(rightIconId);
    }
    return (react_1.default.createElement("strong", { style: { textTransform: 'capitalize' }, "data-testid": "header-month" }, currentMoment.format('MMMM')));
};
exports.default = Header;
//# sourceMappingURL=Header.js.map